import {
  FETCH_BACKEND_WALLETS,
  FETCH_BACKEND_WALLETS_ERROR,
  FETCH_BACKEND_WALLETS_SUCCESS,
  BackendWalletsActions,
} from '../../types/actions/BackendWallets.actions';
import {IBackendWallet} from '../../types/models/BackendWallet';

export interface BackendWalletsState {
  data: IBackendWallet[];
  isLoading: boolean;
}

const initialState: BackendWalletsState = {
  isLoading: false,
  data: [],
};

export default (
  state = initialState,
  action: BackendWalletsActions,
): BackendWalletsState => {
  switch (action.type) {
    case FETCH_BACKEND_WALLETS: {
      return {
        ...state,
        isLoading: true,
      };
    }
    case FETCH_BACKEND_WALLETS_SUCCESS: {
      return {
        ...state,
        isLoading: false,
        data: action.payload,
      };
    }
    case FETCH_BACKEND_WALLETS_ERROR: {
      return {
        ...state,
        isLoading: false,
      };
    }
    default:
      return state;
  }
};
